/** Service worker in prompt mode: a new deploy waits until the player taps "Reload" (never while on a battle). */
import { registerSW } from 'virtual:pwa-register';

let ready = false;
let apply: ((reload?: boolean) => Promise<void>) | null = null;
const listeners = new Set<(r: boolean) => void>();

export function startServiceWorker() {
  apply = registerSW({
    immediate: true,
    onNeedRefresh() { ready = true; for (const l of listeners) l(true); },
    onRegisteredSW(_url, r) { if (r) setInterval(() => { if (navigator.onLine) r.update().catch(() => {}); }, 60 * 60 * 1000); },
  });
  if ('caches' in window) caches.delete('card-art').catch(() => {}); // the old never-revalidated art cache
}
export const onUpdateReady = (l: (r: boolean) => void) => { listeners.add(l); l(ready); return () => { listeners.delete(l); }; };
export const applyUpdate = () => { if (apply) apply(true); else location.reload(); };
